export class Settings {
    constructor(public name: string,
                public loadingSpinner: boolean,
                public fixedHeader: boolean,
                public fixedSidenav: boolean,
                public fixedSidenavUserContent: boolean,
                public fixedFooter: boolean,
                public sidenavIsOpened: boolean,
                public sidenavIsPinned: boolean,
                public menu: string,
                public menuType: string,
                //public theme: string,
                public rtl: boolean) { }
}

import { Injectable } from '@angular/core';
import { environment } from 'environments/base/environment';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'ShiftDigital',     // theme name
        true,               // Use loading spinner
        true,               // Has fixed header
        true,               // Has Fixed Sidenav
        false,              // Has fixed Sidenav User Content
        false,              // Has fixed Footer
        true,               // Is Sidenav open
        true,               // Is Sidenav pinned
        'vertical',         // Horizontal or Vertical Menu
        'default',          // Default, Compact, or Mini Menu
        // environment.theme,         // Theme style sd-light, indigo-light, teal-light, red-light, gray-light, blue-dark, green-dark, pink-dark, gray-dark
        false               // true = right to left, false = left to right
    )
}